export default __webpack_public_path__ + "static/media/clapping.1681be60.mp3";